import "regenerator-runtime/runtime"; // needed for promises and async/await
import { Core } from "../../../VanillaCore";
import {postData} from "../../../webpack-js/api";

export default class PasswordPolicyComponent extends Core.Component {
    loadFeedbackURL = '/VDP/PasswordData.act?type=0';

    constructor(sandbox: Core.Sandbox) {
        super(sandbox);
    }

    init() {
        this.policyNotesDiv = document.querySelector('.policy-notes-div');
        if (this.policyNotesDiv) {
            this.listDiv = this.policyNotesDiv.querySelector('.policy-notes-list');
            this.policyNamePrefixSpan = this.policyNotesDiv.querySelector('.policy-name-prefix');

            window.vdxEventBus.on('on-password-change', ({detail}) => {
                const { proposedPassword, isMatch, overrideUrl } = detail;
                if (proposedPassword && proposedPassword.length > 0) {
                    this.loadFeedback(proposedPassword, (result) => {
                        this.addPasswordMatchesListItem(isMatch);
                    }, overrideUrl || this.loadFeedbackURL);
                }
            });

            window.vdxEventBus.on('on-confirm-password-change', ({detail}) => {
                const { isMatch } = detail;
                this.addPasswordMatchesListItem(isMatch);
            });

            window.vdxEventBus.on('on-password-init', ({detail}) => {
                const { overrideUrl } = detail;
                this.loadFeedback('', (result) => {
                    this.addPasswordMatchesListItem(false);
                }, overrideUrl || this.loadFeedbackURL);
            });
        }
    }

    // eslint-disable-next-line class-methods-use-this
    destroy() {}

    loadFeedback(proposedPassword: String, callback: Function, url: String) {
        postData(url, (result) => {
            if (result.status !== 200) {
                console.error(result);
                this.addItemsToPolicyNotesList([result.data]);
            } else if (result.data instanceof Array) {
                this.addItemsToPolicyNotesList(result.data);
            }

            if (callback !== undefined) {
                callback(result);
            }
        }, {
            proposedPassword: proposedPassword
        });
    }

    addItemsToPolicyNotesList(items: Array) {
        this.clearPolicyNotesList();
        for (let i = 0; i < items.length; i++) {
            this.listDiv.appendChild(
                this.createPolicyListItem(items[i], items[i].includes(i18n.logins.met))
            );
        }
    }

    clearPolicyNotesList() {
        while (this.listDiv.firstChild) {
            this.listDiv.removeChild(this.listDiv.lastChild);
        }
    }

    addPasswordMatchesListItem(isMatch: Boolean) {
        const matchMsg = `${i18n.logins.met} ${i18n.logins.passwordsMatch}`;
        const doesNotMatchMsg = `${i18n.logins.notMet} ${i18n.logins.passwordsDoNotMatch}`;

        this.removeFromPolicyNotesList(matchMsg);
        this.removeFromPolicyNotesList(doesNotMatchMsg);
        this.listDiv.appendChild(this.createPolicyListItem(
            isMatch ? matchMsg : doesNotMatchMsg, isMatch
        ));
    }

    removeFromPolicyNotesList(message: String) {
        for(let child = this.listDiv.firstChild; child !== null; child = child.nextSibling) {
            if (child.textContent === message) {
                this.listDiv.removeChild(child);
                break;
            }
        }
    }

    createPolicyListItem(message: String, meetsReq: Boolean) {
        const li = document.createElement('li');
        if (meetsReq) {
            li.classList.add('meets-requirement');
            li.setAttribute('data-testid', 'meetsRequirementItem');
        } else {
            li.classList.add('does-not-meet-requirement');
            li.setAttribute('data-testid', 'doesNotMeetRequirementItem');
        }
        li.innerText = message;
        return li;
    }

}